import langs from '../../assets/langs.json'
import { OptionSelectInput } from '../InputFields/OptionSelectInput'

interface LanguageSelectorProps {
  language: string
  setLanguage: (language: string) => void
  icon?: JSX.Element
}

function LanguageSelector({ language, setLanguage, icon = undefined }: LanguageSelectorProps) {
  const handleChange = (value: string) => {
    setLanguage(value)
  }

  const langOptions = Object.entries(langs).map(([code, name]) => ({
    value: code,
    label: name,
    icon: icon,
  }))

  return (
    <OptionSelectInput
      customStyles={{
        borderColor: 'gray',
        '&.MuiTextField-root': { width: '100%' },
      }}
      inputStyles={{
        borderColor: 'gray',
        '& .MuiInputBase-root': {
          height: 44,
          background: '#FFF',
          '& .MuiOutlinedInput-notchedOutline': { borderRadius: '8px !important' },
        },
      }}
      options={langOptions}
      placeholder="Select Language"
      // @ts-ignore
      setValue={handleChange}
      value={language}
    />
  )
}

export default LanguageSelector
